import { getAuctionCatalogue } from './auctionCatalogueClient';

export const getBrandsWithAuctions = async (context = {}, options) => {

  return getAuctionCatalogue('getBrandsWithAuctionsV2', context, {}, options);
};
